import React, { useState, useEffect } from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  const [animateClass, setAnimateClass] = useState("");
  
  useEffect(() => {
    if (isOpen) {
      setAnimateClass("md:animate-none animate-slideUp");
    } else if (animateClass.includes("animate-slideUp")) {
      setAnimateClass("md:animate-none animate-slideDown");
      setTimeout(() => setAnimateClass(""), 300);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  if (!isOpen && animateClass !== "animate-slideDown") return null;
  
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm">
      <div className={`bg-white dark:bg-black p-6 rounded-t-lg md:rounded-lg shadow-lg w-full max-w-sm mx-auto transition-transform duration-300 ${animateClass}`}>
        <p className="text-lg font-semibold mb-4 dark:text-white text-black">{message}</p>
        <div className="flex justify-between gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-400 dark:bg-gray-900 dark:border dark:border-gray-700 dark:text-white text-white rounded-md hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
